import { render, staticRenderFns } from "./RedirectCo.vue?vue&type=template&id=3979866c&"
import script from "./RedirectCo.vue?vue&type=script&lang=js&"
export * from "./RedirectCo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports